/* eslint-disable import/prefer-default-export */
const doubleSpaceRegex = /\s+/g;

export {
  doubleSpaceRegex,
};
